import { Button, IconButton, Paper, Typography } from "@material-ui/core"
import { AddCircle, RemoveCircle } from "@material-ui/icons"
import { Image, Transformation } from "cloudinary-react"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import dragGray from "~/assets/Icons/noun_drag_3124730_gray.svg"
import DraftPublishedBox from "~/components/Common/DraftPublishedBox"
import HoverText from "~/components/Common/HoverText"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import PathContext from "~/contexts/Path"
import serialize from "~/store/serialize"
import Box from "../../Common/Box"
import useStyles from "./styles"

const AddedCourseCard = ({
  course,
  type,
  addedCourses,
  setAddedCourses,
  provided,
}) => {
  const classes = useStyles()

  const { courseArray, setCourseArray } = useContext(PathContext)

  const [highlight, setHighlight] = useState(false)
  const [serializedCourse, setSerializedCourse] = useState(null)

  const unpublished =
    !course?.published && course?.has_been_published && !course?.archived

  const draft =
    !course?.published &&
    !course?.has_been_published &&
    !course?.archived &&
    !course?.publish_date

  const archived = !course?.published && course?.archived

  const scheduled =
    !course?.published &&
    !course?.has_been_published &&
    !course?.archived &&
    course?.publish_date

  const addCourse = () => {
    setAddedCourses([...addedCourses, course])
    setHighlight(true)
  }

  const removeCourse = () => {
    setAddedCourses(addedCourses.filter((c) => c.id !== course.id))
    setHighlight(false)
  }

  //remove for view type on pathCourses
  const deleteCourse = () => {
    setCourseArray(courseArray.filter((c) => c.id !== course.id))
  }

  useEffect(() => {
    if (addedCourses?.find((c) => c.id === course.id)) {
      setHighlight(true)
    }
  }, [addedCourses])

  useEffect(() => {
    serialize("course", course).then((res) => setSerializedCourse(res))
  }, [])

  return (
    <Paper
      elevation={0}
      className={classes.paperRow}
      style={{
        backgroundColor: type !== "view" && highlight ? "#D0D5DD" : "#fff",
      }}
      ref={provided?.innerRef}
      {...provided?.draggableProps}
    >
      {serializedCourse?.thumbnail.public_id ? (
        <Image
          publicId={serializedCourse.thumbnail.public_id}
          className={classes.image}
        >
          <Transformation
            width="125"
            crop="fill"
            gravity="auto"
            aspectRatio="16:9"
          />
        </Image>
      ) : (
        <Box className={classes.imgBox}></Box>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        className={classes.cardContainer}
      >
        <Box display="flex" flexDirection="column" marginLeft="8px">
          <Link to={`/courses/${course.id}`}>
            <Box
              style={{ position: "absolute", zIndex: "6", cursor: "pointer" }}
              width={type === "view" ? 225 : 300}
              height={"50px"}
            ></Box>
          </Link>
          {type !== "view" ? (
            <Typography
              variant="h3"
              color="primary"
              style={{ fontWeight: 600, marginBottom: "8px" }}
            >
              {serializedCourse?.name}
            </Typography>
          ) : (
            <HoverText
              data={serializedCourse?.name}
              size={40}
              variant="h3"
              className={classes.name}
            />
          )}
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              color="primary"
              style={{ fontWeight: 600 }}
            >
              Version {serializedCourse?.version}
            </Typography>
            <Typography
              variant="body2"
              style={{ color: "#868686", marginLeft: "4px" }}
            >
              Last Updated {serializedCourse?.updated?.format("M/D/YYYY")}
            </Typography>
            {type !== "view" && serializedCourse?.published ? (
              <Typography
                varaint="body2"
                style={{ color: "#29B117", marginLeft: "8px" }}
              >
                Published
              </Typography>
            ) : null}
            {type !== "view" && unpublished ? (
              <Typography
                varaint="body2"
                style={{ color: "#FF8439", marginLeft: "8px" }}
              >
                Unpublished
              </Typography>
            ) : null}
            {type !== "view" && draft ? (
              <Typography
                varaint="body2"
                style={{ color: "#BC9822", marginLeft: "8px" }}
              >
                Draft
              </Typography>
            ) : null}
            {type !== "view" && archived ? (
              <Typography
                varaint="body2"
                style={{ color: "#808080", marginLeft: "8px" }}
              >
                Archived
              </Typography>
            ) : null}
            {type !== "view" && scheduled ? (
              <Typography
                varaint="body2"
                style={{ color: "#8952D8", marginLeft: "8px" }}
              >
                Scheduled
              </Typography>
            ) : null}
          </Box>
        </Box>
        {type === "view" ? (
          <Box display="flex" alignItems="center">
            <PermissionsWrapper permissionGroup="admin">
              <Box marginRight="8px">
                <IconButton
                  onClick={deleteCourse}
                  className={classes.removeButton}
                >
                  <RemoveCircle />
                </IconButton>
              </Box>
            </PermissionsWrapper>
            <Box marginRight="8px" width={100}>
              <DraftPublishedBox
                published={serializedCourse?.published}
                has_been_published={serializedCourse?.has_been_published}
                archived={serializedCourse?.archived}
              />
            </Box>
            <PermissionsWrapper permissionGroup="admin">
              <div className={classes.dragHandle} {...provided.dragHandleProps}>
                <img src={dragGray} alt="" width="18px" />
              </div>
            </PermissionsWrapper>
          </Box>
        ) : (
          <Box width="15%" className={classes.buttonBox}>
            {highlight ? (
              <Box className={classes.addedBox}>
                <Typography>Added</Typography>
                <PermissionsWrapper permissionGroup="admin">
                  <IconButton
                    className={classes.removeButton}
                    onClick={removeCourse}
                  >
                    <RemoveCircle color="primary" />
                  </IconButton>
                </PermissionsWrapper>
              </Box>
            ) : (
              <PermissionsWrapper permissionGroup="admin">
                <Button
                  className={classes.addButton}
                  classes={{ label: classes.button }}
                  variant="contained"
                  disableElevation
                  startIcon={<AddCircle color="primary" />}
                  onClick={addCourse}
                >
                  <Typography color="primary" className={classes.buttonText}>
                    ADD
                  </Typography>
                </Button>
              </PermissionsWrapper>
            )}
          </Box>
        )}
      </Box>
    </Paper>
  )
}

AddedCourseCard.propTypes = {
  course: PropTypes.object,
  type: PropTypes.string,
  addedCourses: PropTypes.array,
  setAddedCourses: PropTypes.func,
  provided: PropTypes.object,
}

export default AddedCourseCard
